<template>
  <div class="events-table">
    <div class="controls-bar"></div>
    <template v-if="lastFetched">
    <div v-if="tableData.length === 0" class="empty-table">No events to show</div>
      <ve-table
          v-else
          :columns="columns"
          :table-data="tableData"
          row-key-field-name="id"
          :sort-option="sortOption"
          :cellSelectionOption="{ enable: false }"
      />
    </template>
    <template v-else>
      <div class="spinner"><b-spinner variant="primary"/></div>
    </template>
  </div>
</template>

<script>
import Pill from '@/components/Pill.vue'
import { ProgramsActions } from '@/vuex/modules/programs/actions'
import { ProgramsGetters } from '@/vuex/modules/programs/getters'
import { PROGRAMS_NAMESPACE } from '@/vuex/modules/programs/programs.state'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import sortChangeMixin from './sortChangeMixin'

export default {
  name: 'EventsTable',
  mixins: [ sortChangeMixin ],
  components: { },
  data () {
    return {
      lastFetched: null,
      tableData: [],
      sortOption: {
        sortChange: (params) => this.sortChange(params)
      },
      columns: [
        {
          field: 'id',
          key: 'a',
          title: 'ID',
          align: 'center',
          sortBy: '',
          width: '10%'
        },
        {
          field: 'name',
          key: 'b',
          title: 'Name',
          align: 'left',
          sortBy: ''
        },
        {
          field: 'source',
          key: 'c',
          title: 'Source',
          align: 'left',
          sortBy: '',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.source ? <Pill large color=''>{row.source.toUpperCase()}</Pill> : ''
          }
        },
        {
          field: 'created_at',
          key: 'd',
          title: 'Time',
          align: 'center',
          sortBy: '',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (row.created_at) {
              return moment(row.created_at).format('DD.MM.YYYY hh:mm:ss')
            }
            return 'Not set'
          }
        },
        {
          field: 'status',
          key: 'e',
          title: 'Status',
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (row.status === 'done') {
              return row.status ? <Pill large color="green">{ row.status.toUpperCase() }</Pill> : ''
            } else if (row.status === 'error') {
              return row.status ? <Pill large color="red">{ row.status.toUpperCase() }</Pill> : ''
            } else {
              return row.status ? <Pill large>{ row.status.toUpperCase() }</Pill> : ''
            }
          }
        }
      ]
    }
  },
  created () {
    const { companyCode } = this.$route.params
    const program = this.$props?.program

    if (this.lastFetched === null) {
      this.fetchProgramEvents({ companyCode, program }).then(r => {
        this.tableData = [ ...this.getProgramEvents(program?.id) ]
      }).catch(e => {
        this.tableData = null
      }).finally(() => {
        this.lastFetched = new Date()
      })
    } else {
      this.tableData = [ ...this.fetchProgramEvents(program?.id) ]
    }
  },
  props: {
    participants: Array,
    program: Object
  },
  methods: {
    ...mapActions(PROGRAMS_NAMESPACE, {
      fetchProgramEvents: ProgramsActions.fetchProgramEvents
    })
  },
  computed: {
    ...mapGetters(PROGRAMS_NAMESPACE, {
      getProgramEvents: ProgramsGetters.getProgramEvents
    })
  }
}
</script>

<style lang="scss">

.events-table > div > div >div >table > thead > tr > th {
    font-weight: 800 !important;
}
.events-table > div > div >div >table > thead > tr > th > span.ve-table-sort{
    translate: 0 -25%;
}
.events-table > div > div >div >table > thead > tr > th > label > span.ve-checkbox-content{
    translate: 0 25%;
}

.events-table > div > div > div > table > tbody > tr.ve-table-body-tr > td {
  transition: background 1s;
}

.events-table > div > div > div > table > tbody > tr.ve-table-body-tr > td.hot {
  background: lightseagreen !important;
  transition: background 1s;
}

</style>

<style scoped>

.events-table {
  margin: 0 0 60px 0;
}

.controls-bar {
  display: flex;
  justify-content: flex-end;
  margin-right: 1em;
  padding: 5px;
  gap: 1rem;
}

.empty-table {
  display: flex;
  justify-content: center;
}

.dropdown {
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
}

.dropdown-placer {
  position: relative;
  height: 1px;
}

.dropdown-menu {
  background: white;
  position: absolute;
  min-width: 100%;
  z-index: 9999;
  top: 0;
  right:0;
  margin-top: -1px;
}

.spinner {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-height: 2rem;
}
</style>
